// extracted by mini-css-extract-plugin
export default {"filters":"FiltersBlock_filters__T+vf3","filters_close":"FiltersBlock_filters_close__JHVp3"};